import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getQueryVariable, removeCookie } from "../utils/helper";
import { SplashScreenView, useApp } from "../contexts";
import { KEY_COOKIE } from "../constants";
import { getCookie } from "../utils/helper";

const ConfirmPhone = () => {
  const location = useLocation();
  const { logout, user } = useApp();

  useEffect(() => {
    if (location.search.includes("status")) {
      let value = getQueryVariable(location, "status");
      value = parseInt(value);
      const isAffiliateApp = localStorage.getItem("isAffiliateApp");
      if (value) {
        if (isAffiliateApp) {
          localStorage.removeItem("isAffiliateApp");
          window.location.href = "/affiliate?app=1";
        }else {
          const redirect_uri = getCookie("redirect_uri");
          if (redirect_uri) {
            removeCookie("redirect_uri");
            window.location.href = redirect_uri;
          }else{
            window.location.href = "/";
          }
        }
      } else {
        logout();
      }
    }else{
      const sso_token = getCookie(KEY_COOKIE.AUTH_TOKEN_COOOKIE)?.access_token;
      if (
        location.search.includes("redirect_uri") 
        && !user?.verify_phone_status &&
        !!user?.email &&
        !!user?.token &&
        !!user?.id &&
        sso_token) {
        const redirect_uri = encodeURIComponent(`${process.env.REACT_APP_SSO_BASE_HOME}confirm-phone`);
        const urlIframe = `${process.env.REACT_APP_SSO_VERIFY_PHONE}?access_token=${sso_token}&p=web&redirect_uri=${redirect_uri}`;
        return window.location.replace(urlIframe);
      }
        
    }
  }, [location]);

  return <SplashScreenView />;
};

export default ConfirmPhone;
